<section>
    <pdf-view [dealId]="dealId" [docId]="docId" [document]="document" [template]="template" [allowGuidedSigning]="false" (outEvent)="eventHandler($event)">
    </pdf-view>
</section>

<ddj-spinner *ngIf="isLoading"></ddj-spinner>
